import React from "react";
import "./footer.scss";
import logo from "../images/SpectrumAcceptanceLogo.svg";
import { Link } from "gatsby";

function Footer() {
  return (
    <footer className="footer" id="contact-us">
      <div className="footer__container">
        <div>
          <h2 className="heading">Contact Us</h2>
          <p>
            For questions regarding your account, how to make a payment, or
            general inquiries, please fill out our Email Form or give us a call.
            Please have your account number available for quicker assistance.
          </p>
        </div>
        <address className="footer__address">
          <div>
            <h3>Address</h3>
            Spectrum Aceptance <br /> 7135 S Highland Drive, Suite 100 <br />
            Salt Lake City, UT 84121
          </div>
          <div>
            <h3>Phone</h3>
            <a href="tel:+18015420639">US (801)542-0639</a>
          </div>
          <div>
            <h3>Email</h3>
            <a href="mailto:info@spectrumacceptance.com">
              info@spectrumacceptance.com
            </a>
          </div>
        </address>
        <a
          className="btn--green"
          href="https://spectrum.accountportalonline.com/"
        >
          Make a Payment
        </a>
      </div>
      <div className="footer__bar">
        <div className="footer__bar-container">
          <img src={logo} alt="" />
          <Link to="/terms-and-conditions">Terms and Conditions</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
